import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="home-page">
      <div className="container">
      <header>
  <h1>TT Saver</h1>
        <p className="subtitle">Save videos quickly from supported platforms</p>
      </header>

      <p className="effective-date">Effective Date: October 7, 2025</p>

      <div className="section">
        <h2>How to use our app?</h2>
        <ul>
          <li>Choose a video you want to save (supported: TikTok & DouYin)</li>
          <li>Click "Share" and then click "Copy link"</li>
          <li>Open TT Saver (the "App")</li>
          <li>Click "Download Video"</li>
          <li>Saved videos will be added to your gallery.</li>
        </ul>
      </div>

      <div className="section">
        <h2>Important information</h2>
        <ul>
          <li>This app and its creators are not affiliated with Bytedance.</li>
          <li>Please respect the copyright of content creators; do not distribute content without permission.</li>
          <li>We are not responsible for any infringement of intellectual property rights resulting from unauthorized reposting of videos or photos.</li>
        </ul>
      </div>

      <div className="contact-info">
        <h2>About us</h2>
        <p>
          <a href="mailto:support@tsmallin.com">support@tsmallin.com</a>
        </p>
        <p>
          <Link to="/privacy">Privacy Policy</Link> · <Link to="/terms">Terms of Service</Link>
        </p>
      </div>

      <footer>
        <p>© {new Date().getFullYear()} TT Saver. All rights reserved.</p>
      </footer>
      </div>
    </div>
  );
};

export default Home;
